<template>
  <section fluid>
    <section class="section-box section-box-list" style="padding: 30px;">
      <div>
        <v-text-field v-model="currentNote.title" label="Título" required single-line></v-text-field>
      </div>
      <div>
        <v-textarea v-model="currentNote.comment" label="Comentário" required></v-textarea>
      </div>
      <div>
        <p class="text-xs-right">
          <v-btn round large depressed color="success" :loading="loadingRequest"
            @click.stop="saveNote()">
            <span v-if="!currentNote._id">Adicionar anotação</span>
            <span v-else>Salvar anotação</span>
          </v-btn>
        </p>
      </div>
    </section>

    <v-list two-line style="background: transparent;" v-if="notes && notes.length">
      <template v-for="note in notes.slice().reverse()">
        <v-list-tile class="section-box section-box-list" :key="note.title">
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>{{ note.title }}</strong> -
              <v-tooltip bottom>
                <span slot="activator">{{ note.updated_at | moment('from', 'now') }}</span>
                <span>{{ note.updated_at | moment('DD/MM/Y, HH:mm') }}</span>
              </v-tooltip>
            </v-list-tile-title>
            <v-list-tile-sub-title v-html="note.comment"></v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-list-tile-action-text>
              <v-btn flat icon color="blue-grey lighten-2" @click="currentNote = note">
                <v-icon small>fal fa-edit</v-icon>
              </v-btn>
              <v-btn flat icon color="red lighten-2" @click="deleteNote(note)">
                <v-icon small>fal fa-trash-alt</v-icon>
              </v-btn>
            </v-list-tile-action-text>
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </v-list>
  </section>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

export default {
  name: 'AdminUserShowNotes',

  data: () => ({
    user: {},
    loadingRequest: false,
    currentNote: {},
    notes: []
  }),

  methods: {
    loadNotes () {
      // eslint-disable-next-line
      axios.get(API.userNotes + '/users/' + this.$route.params.id).then(response => {
        this.notes = response.data.notes
        this.currentNote = {}
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar as notas',
          color: 'error'
        })
      })
    },

    createNote () {
      // eslint-disable-next-line
      axios.post(API.userNotes + '/users/' + this.$route.params.id, this.currentNote).then(response => {
        this.loadNotes()
        this.loadingRequest = false
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar as notas',
          color: 'error'
        })
      })
    },

    deleteNote (note) {
      // eslint-disable-next-line
      axios.delete(API.userNotes + '/' + note._id).then(response => {
        this.loadNotes()
        this.loadingRequest = false
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar as notas',
          color: 'error'
        })
      })
    },

    editNote () {
      // eslint-disable-next-line
      axios.put(API.userNotes + '/' + this.currentNote._id, this.currentNote).then(response => {
        this.loadNotes()
        this.loadingRequest = false
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar as notas',
          color: 'error'
        })
      })
    },

    saveNote () {
      this.loadingRequest = true

      if (this.currentNote._id) {
        this.editNote()
      } else {
        this.createNote()
      }
    }
  },

  created () {
    this.loadNotes()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/userShow/AdminUserShowNotes.vue